<template>
    <div>
        <div class="c-reservation-summary__item">
            <div class="c-reservation-summary__label">
                {{ $t('BranchReservation.Summary.Voucher.title') }}
            </div>

            <div class="c-reservation-summary__voucher">
                <div class="c-reservation-voucher">
                    <div class="c-reservation-voucher__input">
                        <div class="c-form__item c-form__item--text has-addon">
                            <input
                                type="text"
                                name="voucher"
                                :placeholder="placeholder"
                                id="voucher"
                                class="form-control c-form__input"
                                aria-invalid="false"
                                v-model="voucher"
                                :readonly="isUpdatingVoucher || !isInitialized"
                                @keyup.enter="onVoucherAddClick"
                            />
                            <button
                                type="button"
                                class="c-btn c-btn--secondary"
                                :class="{
                                    'is-loading': isUpdatingVoucher
                                }"
                                @click.prevent="onVoucherAddClick"
                                ref="submitButton"
                                :disabled="!isInitialized"
                            >
                                {{ $t('BranchReservation.Summary.Voucher.add') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-reservation-voucher__codes" v-if="vouchers">
            <div
                class="c-reservation-voucher__item"
                v-for="voucher in vouchers"
                :key="voucher.cart_id"
            >
                <span class="sc-code">{{ voucher.code }}</span>

                <button
                    class="btn btn--invisible"
                    type="button"
                    @click.prevent="onVoucherDeleteClick(voucher.cart_id)"
                >
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { tippyAlert } from "Functions/tippy"
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            voucher: '',
        }
    },
    computed: {
        ...mapState([
            'vouchers',
            'isUpdatingVoucher',
            'isInitialized',
        ]),
        placeholder() {
            if (this.vouchers && this.vouchers.length) {
                return this.$t('BranchReservation.Summary.Voucher.placeholderMore')
            }

            return this.$t('BranchReservation.Summary.Voucher.placeholder')
        }
    },
    methods: {
        ...mapActions([
            'addVoucher',
            'removeVoucher'
        ]),
        async onVoucherAddClick() {
            if (
                !this.voucher ||
                this.isUpdatingVoucher
            ) {
                return
            }

            this.addVoucher(this.voucher).then((response) => {
                if (!response) return

                if (response.error) {
                    tippyAlert(this.$refs.submitButton, response.message, {
                        theme: 'error'
                    })

                    return
                }

                tippyAlert(this.$refs.submitButton, response.data.message)
                this.voucher = ''
            })
        },
        async onVoucherDeleteClick(voucherCartId) {
            if (this.isUpdatingVoucher) {
                return
            }

            this.removeVoucher(voucherCartId).then((response) => {
                if (!response) return

                if (response.error) {
                    tippyAlert(this.$refs.submitButton, response.message, {
                        theme: 'error'
                    })

                    return
                }

                tippyAlert(this.$refs.submitButton, response.data.message)
            })
        }
    }
}
</script>